<form
    [formGroup]="accessCodeForm"
    [@demoAnimation]="{
        value: '',
        params: {
            time: ((lastFormTracker | async) === 'ACCESSCODE') ? '0ms': '200ms',
            from: ((lastFormTracker | async) === 'ACCESSCODE') ? '0%': '-40%'
        }}">
    <mat-form-field class="w-full" appearance="fill">
        <mat-label>{{ 'page.login.form.accessCode.accessCodeField.label' | translate }}</mat-label>
        <input
            matInput
            appFieldLength="3"
            noWhiteSpace="WIPE"
            id="txtLoginAccessCode"
            type="text"
            placeholder="{{ 'page.login.form.accessCode.accessCodeField.label' | translate }}"
            formControlName="code"
        />
        <mat-error *ngIf="accessCodeForm.get('code')?.hasError('required')">
            {{ 'page.login.form.accessCode.accessCodeField.requiredMessage' | translate }}
        </mat-error>
        <mat-error *ngIf="accessCodeForm.get('code')?.hasError('maxLength') || accessCodeForm.get('code')?.hasError('invalidLength')">
            {{ 'page.login.form.accessCode.accessCodeField.maxLengthMessage' | translate }}
        </mat-error>
    </mat-form-field>

    <div class="BtnWrapper">
        <button
            type="submit"
            kendoButton
            id="btnNext"
            color="primary"
            name="next-button"
            [disabled]="!accessCodeForm.valid"
            (click)="proceedForLogin()">
            {{ 'page.login.form.accessCode.proceedButton' | translate }}
        </button>
    </div>
</form>
